var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sports-tabs" }, [
    _c("div", { staticClass: "sports-tabs-wrap" }, [
      _c(
        "ul",
        { staticClass: "tabs" },
        _vm._l(_vm.sportList, function (s, idx) {
          return _c(
            "li",
            {
              key: idx,
              class: [
                _vm.sportDetails[s].className,
                "no-select",
                { active: _vm.current_sport === s },
                { "btn-disabled": !_vm.sportDetails[s].hasMatches },
              ],
            },
            [
              _c("a", { attrs: { href: _vm.getFirstNodeHref(s) } }, [
                _c("span", { staticClass: "txt" }, [
                  _vm._v(_vm._s(_vm.sportDetails[s].name)),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }